export default __webpack_public_path__ + "static/media/ic-logo-mobile.99001397.svg";